import { render, staticRenderFns } from "./MobileLeftPanel.vue?vue&type=template&id=3d2daaa0&"
import script from "./MobileLeftPanel.vue?vue&type=script&lang=js&"
export * from "./MobileLeftPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2daaa0')) {
      api.createRecord('3d2daaa0', component.options)
    } else {
      api.reload('3d2daaa0', component.options)
    }
    module.hot.accept("./MobileLeftPanel.vue?vue&type=template&id=3d2daaa0&", function () {
      api.rerender('3d2daaa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/MobileLeftPanel.vue"
export default component.exports